import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-clear-filter-button',
  templateUrl: './clear-filter-button.component.html',
  standalone: false,
})
export class ClearFilterButtonComponent extends AppBaseComponent {
  @Output() clearFilter = new EventEmitter<boolean>();

  onClick(): void {
    this.clearFilter.emit(true);
  }
}